import { isRevocable, type AdminCode } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

/**
 * The line's own live SHARED code. A roster line owns the roster-wide one (no cohort); a cohort
 * line owns the one pinned to it. Each line has at most one, which is what lets both write doors
 * act on the line rather than on a chosen target.
 *
 * A RESERVED code is held for one named person — an invitation, not the line's shared code. It is
 * excluded here rather than only fenced at the door, because the line's code and the code its
 * Revoke destroys are the same value by construction: were a reserved code eligible, a line
 * holding one would DISPLAY the invitation and the destructive door would target it.
 */
export const activeCodeForLine = (
  codes: readonly AdminCode[],
  cohortId: number | null,
): AdminCode | null =>
  codes.find(
    (code) =>
      isRevocable(code) &&
      !code.isReserved &&
      (cohortId === null ? code.cohort === null : code.cohort?.id === cohortId),
  ) ?? null;

/**
 * Which line a write was fired from. One mutation instance serves every line, so its isLoading
 * is global — without a line to compare against, one line's write shows every line as pending.
 */
export const rosterLineKey = (rosterId: number): string => `roster:${rosterId}`;

export const cohortLineKey = (cohortId: number): string => `cohort:${cohortId}`;
